/** @module ProductSpec/SizeChart/SizeChartDimensionLinkedToShapeRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Boolean"
], function(declare,BooleanRen) {
	return declare(BooleanRen, {
		/**
		 * Disable filtering
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.notFilterable = true;
			return qs;
			
		},

		/**
		 * Return true if SizeChartDimension.ShapeSysID is initialized
		 */
		_getValue: function(ctx, h) {
			return !!ctx.getNode().ShapeSysID;
		},

		/**
		 * Format at Boolean instead of String
		 */
		_getCSS: function(type, format) {
			return "attrBoolean";
		}
	});
});
